// Kleines rundes Diet-Badge (Veggie/Vegan) im Tæste-Grün.
// Nutzt lokal definierte SVG-Grafik, keine Emojis.

const VeggieIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <circle cx="12" cy="12" r="11" fill="hsl(122 38% 92%)" stroke="hsl(122 42% 34%)" strokeWidth="1.4" />
    {/* zwei Blätter */}
    <path
      d="M8.5 15.5c1.6-4 4.5-6.4 7-7 -0.5 3-2.3 6.4-5.3 7.4-0.9 0.3-1.8 0-1.7-0.4z"
      fill="hsl(122 42% 34%)"
    />
    <path
      d="M12 16c0.5-2.6 2.4-4.6 4.5-5.2 -0.2 2-1.5 4.4-3.5 5.2-0.6 0.2-1 0.1-1-0z"
      fill="hsl(122 55% 46%)"
    />
    <path d="M15.5 8.5c-2 1.5-4 4-4.5 7" fill="none" stroke="hsl(122 42% 28%)" strokeWidth="0.8" strokeLinecap="round" />
  </svg>
);

const VeganIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <circle cx="12" cy="12" r="11" fill="hsl(96 50% 90%)" stroke="hsl(96 55% 42%)" strokeWidth="1.4" />
    {/* Blatt mit Häkchen */}
    <path
      d="M9 15.5c1.5-3.5 4-5.6 7-6.2 -0.3 2.9-2 6-4.7 7.2-1.2 0.5-2.6 0-2.3-1z"
      fill="hsl(96 55% 42%)"
    />
    <path d="M9.8 12.8l1.6 1.6 3.2-3.4" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function DietBadge({ diet }) {
  if (!diet) return null;
  const label = diet === "vegan" ? "Vegan" : "Vegetarisch";
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      data-testid={`diet-badge-${diet}`}
      className="inline-flex items-center align-middle ml-2"
    >
      {diet === "vegan" ? <VeganIcon /> : <VeggieIcon />}
    </span>
  );
}
